import { constants } from "@cinch-nx/data-search";
const { defaultFilters , defaultNonFilterParams , searchFilterKeys  } = constants;
export function convertRawSearchFiltersToSearchFilters(raw, allCinchStores) {
    const parsedEntries = Object.fromEntries(Object.entries(raw).map(([key, value])=>{
        // when store=all-stores in the URL, filter on all possible individual store names
        if (key === "store" && value === "all-stores") {
            return [
                key,
                allCinchStores
            ];
        } else if (searchFilterKeys.includes(key)) {
            return [
                key,
                value.split(",")
            ];
        } else if (key === "useMonthly") {
            return [
                key,
                value === "true"
            ];
        } else {
            return [
                key,
                Number.parseInt(value)
            ];
        }
    }));
    return {
        ...defaultFilters,
        ...defaultNonFilterParams,
        ...parsedEntries
    };
}
